import Field from 'components/forms/field/Field';
import type { FC } from 'react';

export const PercentShapeConfigFields: FC = () => {
    return (
        <>
            <Field.Label label='Options' />
            <div className='w-full'>
                <Field.Toggle
                    label='Range is between 0 and 1'
                    name='asZeroToOne'
                    help='Percentage values are ranged between 0 and 1.'
                />
            </div>
            <Field.Input
                label='Decimal Places'
                name='decimalPlaces'
                type='number'
                min='0'
                max='10'
                className='w-28'
                help='Must be between 0 and 20. Clearing the field resets back to the default for the selected type.'
            />
        </>
    );
};
